import { useMemo } from 'react';
import type { PermissionScope } from '@application/ports';
import { useSession } from '../providers/SessionProvider';

/**
 * Which absences «Mis ausencias» shows: the viewer's own, always.
 *
 * It used to widen with the role — an administrator read the whole area and a
 * leader their sub area — which put other people's records under a heading that
 * says «Mis», and put a leader's own permit in the same list as the ones they
 * were meant to decide on. A screen that mixes "what I asked for" with "what
 * others are asking me" makes the reader check, on every row, which one they are
 * looking at.
 *
 * Other people's absences live in Aprobaciones now, beside the vacation board
 * that always held them. That is the whole rule, and it is stated here rather
 * than repeated in four screens so it cannot drift back apart.
 *
 * The shape is `PermissionScope`, which `IncapacityScope` and `RequestScope`
 * match field for field; every repository reads the same key.
 */
export interface AbsenceScope {
  readonly scope: Pick<PermissionScope, 'personId'>;
}

export const useAbsenceScope = (): AbsenceScope => {
  const session = useSession();
  return useMemo(() => ({ scope: { personId: session.personId } }), [session.personId]);
};
